import { createFileRoute, redirect } from '@tanstack/react-router'
import { AdminDashboard } from '@/pages/AdminDashboard'
import { supabase } from '@/lib/supabase'

export const Route = createFileRoute('/dashboard')({
  component: AdminDashboard,
  beforeLoad: async () => {
    // Check user type and permissions
    const { data: { session } } = await supabase.auth.getSession();

    if (!session?.user) {
      // Not authenticated - redirect to home
      throw redirect({ to: '/' });
    }

    const userType = session.user.user_metadata?.['user_type'];

    // Redirect staff to their appropriate dashboard
    if (session.user.user_metadata?.['role']) {
      const role = session.user.user_metadata['role'];
      if (role === 'server') {
        throw redirect({ to: '/staff-server' });
      } else if (role === 'kitchen') {
        throw redirect({ to: '/staff-kitchen' });
      }
    }

    // For assistants, check if they have dashboard permission
    if (userType === 'assistant') {
      const { data: assistant } = await supabase
        .from('assistants')
        .select('permissions')
        .eq('id', session.user.id)
        .single();

      // Check if assistant has dashboard view permission
      const permissions = assistant?.permissions as { dashboard?: { view?: boolean } } | null;
      const hasDashboardPermission = permissions?.dashboard?.view === true;

      if (!hasDashboardPermission) {
        // No dashboard permission - redirect to assistant dashboard
        throw redirect({ to: '/assistant-dashboard' });
      }
    }

    // Admins and assistants with dashboard permission can access this route
  },
})
